// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "_" + {"141":"7ded04f","169":"129a0a1","658":"11d6244"}[chunkId] + ".css";
};